"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultState = void 0;
var _authentication = require("../../types/authentication");
var _requestStatus = require("../../types/requestStatus");
const defaultState = exports.defaultState = {
  checkEmail: {
    status: _authentication.ECheckEmailStatus.Initial
  },
  authenticate: {
    status: _authentication.EAuthenticateStatus.Initial
  },
  twoFactor: {
    phoneState: {
      status: _requestStatus.ERequestStatus.Initial,
      phone: '',
      secondsToRetry: null,
      senderType: null,
      isAutosubmitEnabled: true,
      error: null
    }
  },
  restore: {
    status: _authentication.ERestoreStatus.Initial
  },
  password: ''
};